<template>
  <div class="product-store-pricing-import">
    <KTCodePreview v-bind:title="'Import cấu hình giá sản phẩm'">
      <template v-slot:toolbar>
        <b-button
          variant="secondary"
          size="sm"
          @click="$router.push({ name: 'list-products' })"
        >
          <i class="fas fa-arrow-left mr-2"></i>
          Quay lại
        </b-button>
      </template>
      <template v-slot:preview>
        <ProductPricingImportModal />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ProductPricingImportModal from './components/ProductPricingImportModal.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

export default {
  name: 'ProductStorePricingImport',
  components: {
    KTCodePreview,
    ProductPricingImportModal,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Sản phẩm', route: '/products' },
      { title: 'Import cấu hình giá' },
    ]);
  },
};
</script>

<style lang="scss" scoped></style>
